import React from 'react';

interface BillingKpiCardProps {
  title: string;
  value: string;
  subtitle?: string;
  icon: React.ForwardRefExoticComponent<React.SVGProps<SVGSVGElement> & { title?: string }>;
  color: 'blue' | 'green' | 'red' | 'purple' | 'amber' | 'indigo' | 'emerald';
}

const COLOR_MAP: Record<BillingKpiCardProps['color'], { bg: string; border: string; text: string; icon: string; value: string }> = {
  blue:   { bg: 'bg-lex-accent-soft',     border: 'border-lex-accent',     text: 'text-lex-accent',     icon: 'text-lex-accent',     value: 'text-gray-900 dark:text-white' },
  green:  { bg: 'bg-green-50 dark:bg-green-900/20',    border: 'border-green-200 dark:border-green-800',   text: 'text-green-600 dark:text-green-400',   icon: 'text-green-500 dark:text-green-400',   value: 'text-green-900 dark:text-green-100' },
  red:    { bg: 'bg-red-50 dark:bg-red-900/20',        border: 'border-red-200 dark:border-red-800',       text: 'text-red-600 dark:text-red-400',       icon: 'text-red-500 dark:text-red-400',       value: 'text-red-900 dark:text-red-100' },
  purple: { bg: 'bg-purple-50 dark:bg-purple-900/20',  border: 'border-purple-200 dark:border-purple-800', text: 'text-purple-600 dark:text-purple-400', icon: 'text-purple-500 dark:text-purple-400', value: 'text-purple-900 dark:text-purple-100' },
  amber:  { bg: 'bg-amber-50 dark:bg-amber-900/20',    border: 'border-amber-200 dark:border-amber-800',   text: 'text-amber-600 dark:text-amber-400',   icon: 'text-amber-500 dark:text-amber-400',   value: 'text-amber-900 dark:text-amber-100' },
  indigo:  { bg: 'bg-lex-accent-soft',   border: 'border-lex-accent',   text: 'text-lex-accent',   icon: 'text-lex-accent',   value: 'text-gray-900 dark:text-white' },
  emerald: { bg: 'bg-emerald-50 dark:bg-emerald-900/20', border: 'border-emerald-200 dark:border-emerald-800', text: 'text-emerald-600 dark:text-emerald-400', icon: 'text-emerald-500 dark:text-emerald-400', value: 'text-emerald-900 dark:text-emerald-100' },
};

const BillingKpiCard: React.FC<BillingKpiCardProps> = ({ title, value, subtitle, icon: Icon, color }) => {
  const c = COLOR_MAP[color];
  return (
    <div className={`${c.bg} ${c.border} border rounded-lg p-4`}>
      <div className="flex items-center gap-3">
        <Icon className={`h-6 w-6 ${c.icon} flex-shrink-0`} />
        <div className="min-w-0">
          <div className={`text-sm font-medium ${c.text}`}>{title}</div>
          <div className={`text-2xl font-bold ${c.value} truncate`}>{value}</div>
          {subtitle && (
            <div className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">{subtitle}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BillingKpiCard;
